<template>

  <v-switch
    v-if="missionAsset.isFault"
    v-model="faultsResolvedAsBoolean"
    hide-details
    color="green"
    @click.native.stop=""
    label="Faults Resolved"
    class="mt-0 pt-0 d-inline-block"
    :disabled="loading || ! userCanToggleFaultsResolved"
    :loading="loading">
  </v-switch>

</template>

<script>
import { denormalize } from "@/helpers/JsonApiDenormalizer";
import { MissionAssetService } from "@/services/missionAsset.service";

export default {
  name: 'MissionAssetFaultsResolvedToggle',
  props: {
    missionAsset: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    faultsResolvedAsBoolean: null,
  }),
  computed: {
    userCanToggleFaultsResolved() {
      const is_contractor = this.$store.getters['auth/isContractor'];
      return is_contractor === false; // explicit false here should mean non-contractor
    }
  },
  created() {
    //
  },
  mounted() {
    // Setup the initial state of the boolean
    if (this.missionAsset && this.missionAsset.id && _.isNull(this.faultsResolvedAsBoolean)) {
      this.faultsResolvedAsBoolean = this.missionAsset.faults_resolved_at ? true : false;
    }
  },
  watch: {
    faultsResolvedAsBoolean(next, prev) {
      // Ignore the first change (when value gets initialized)
      if (_.isNull(prev)) return false;
      this.loading = true;
      MissionAssetService.toggleFaultsResolved(this.missionAsset.id, next)
        .then(response => {
          const ma = denormalize(response.data);
          this.$emit('mission-asset-updated', ma);
        })
        .catch(err => {
          this.$store.commit("snacktime", {
            color: 'error',
            text: "Failed to update faults resolution state."
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  }
};
</script>

<style lang="scss"></style>
